import { Box, Flex } from "@radix-ui/themes";
import { Navbar } from "../components/Navbar";
import { useCallback, useContext } from "react";
import { AccountContext, WebSocketContext } from "../App.tsx";
import {
  createAccountREST,
  loginAccountREST,
  // playerJoin,
  // setPlayerProfile,
} from "../api.ts";
import { Countdown } from "../components/Countdown.tsx";
import * as Form from "@radix-ui/react-form";
import AvatarSelector from "../components/AvatarSelector";
import { Link } from "react-router-dom";
import { toast } from "../components/Toasts.tsx";

function Account() {
  const [account, setAccount] = useContext(AccountContext);
  const websocket = useContext(WebSocketContext);

  const login = useCallback(
    async (_websocket: WebSocket, account_name: string, password: string) => {
      console.log(`login ${account_name}`);
      try {
        // Use RESTful API for login
        const loginResponse = await loginAccountREST(account_name, password);
        // Set account in context
        if (
          loginResponse.LoginActionResponse &&
          loginResponse.LoginActionResponse.magic
        ) {
          const accountData = {
            account_name: account_name,
            password: "hidden", // Don't store actual password
            dispatch_url: loginResponse.LoginActionResponse.dispatch_url,
            magic: loginResponse.LoginActionResponse.magic,
            eternal_magic_hash:
              loginResponse.LoginActionResponse.eternal_magic_hash,
            alcohol: 100, // default value, can be updated later
            health: 100, // default value, can be updated later
            score: 0, // default value, can be updated later
          };
          setAccount(accountData);
        } else {
          console.error("Login failed");
          toast(
            "Login Failed",
            loginResponse.LoginActionResponse?.message || "Unknown error",
            "error",
          );
        }
      } catch (error) {
        console.error("Error logging in:", error);
        toast(
          "Login Error",
          error instanceof Error ? error.message : String(error),
          "error",
        );
      }
    },
    [setAccount],
  );

  const createNewAccount = useCallback(
    async (websocket: WebSocket, account_name: string, password: string) => {
      // Use RESTful API for account creation
      const response = await createAccountREST(account_name, password);
      if (
        (response.CreateAccountResponse || response.LoginActionResponse) &&
        (response.CreateAccountResponse?.magic ||
          response.LoginActionResponse?.magic)
      ) {
        // alert("Account created successfully! Now logging in...");
        login(websocket, account_name, password);
      }
    },
    [login],
  );

  return (
    <Box>
      <Navbar />
      <Countdown />
      <Flex justify={"center"}>
        <Box width={"1000px"} style={{ marginTop: "50px" }}>
          <Box
            style={{
              backgroundColor: "rgba(12, 16, 22, 0.82)", // Dark blue with 90% opacity
              padding: "20px",
              marginTop: "10px",
              marginBottom: "10px",
              borderRadius: "6px", // Optional: adds rounded corners
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Optional: adds a subtle shadow
            }}
          >
            {!account && websocket && (
              <Box>
                <Box
                  style={{
                    margin: "10px",
                    padding: "10px",
                    backgroundColor: "rgba(28, 36, 46, 0.85)", // Slightly lighter blue with 90% opacity
                    borderRadius: "4px", // Optional: adds rounded corners
                  }}
                >
                  <Box
                    style={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      color:
                        "var(--ro-text)" /* Highlight color to match new color scheme */,
                    }}
                  >
                    <Form.Root
                      className="FormRoot"
                      onSubmit={(event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const account_name = formData.get(
                          "account_name",
                        ) as string;
                        const password = formData.get("password") as string;
                        if (websocket) {
                          login(websocket, account_name, password);
                        }
                      }}
                    >
                      <Form.Field className="FormField" name="account_name">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between",
                          }}
                        >
                          <Form.Label
                            className="FormLabel"
                            style={{
                              color:
                                "var(--ro-text)" /* Highlight color to match new color scheme */,
                            }}
                          >
                            Username
                          </Form.Label>
                          <Form.Message
                            className="FormMessage"
                            match="valueMissing"
                            style={{
                              color:
                                "var(--ro-text)" /* Highlight color to match new color scheme */,
                            }}
                          >
                            Please enter your username
                          </Form.Message>
                        </div>
                        <Form.Control asChild>
                          <input
                            className="Input"
                            type="account_name"
                            name={"account_name"}
                            required
                          />
                        </Form.Control>
                      </Form.Field>
                      <Form.Field className="FormField" name="password">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between",
                          }}
                        >
                          <Form.Label
                            className="FormLabel"
                            style={{
                              color:
                                "var(--ro-text)" /* Highlight color to match new color scheme */,
                            }}
                          >
                            Password
                          </Form.Label>
                          <Form.Message
                            className="FormMessage"
                            match="valueMissing"
                          >
                            Please enter your password
                          </Form.Message>
                        </div>
                        <Form.Control asChild>
                          <input
                            className="Input"
                            type="password"
                            name={"password"}
                            required
                          />
                        </Form.Control>
                      </Form.Field>
                      <Form.Submit asChild>
                        <button
                          className="Button"
                          style={{
                            marginTop: 10,
                            border: "1px solid var(--ro-accent)", // Highlight color border
                            padding: "10px",
                            cursor: "pointer",
                            backgroundColor: "var(--ro-panel-solid)", // Dark blue color to match new color scheme
                            color: "var(--ro-text)", // Highlight color to match new color scheme
                            borderRadius: "4px", // Optional: adds rounded corners
                          }}
                        >
                          Log in
                        </button>
                      </Form.Submit>
                    </Form.Root>
                  </Box>
                </Box>
                <Box
                  style={{
                    margin: "10px",
                    padding: "10px",
                    backgroundColor: "rgba(28, 36, 46, 0.85)", // Slightly lighter blue with 90% opacity
                    borderRadius: "4px", // Optional: adds rounded corners
                  }}
                >
                  <Box
                    style={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <Form.Root
                      className="FormRoot"
                      onSubmit={(event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const account_name = formData.get(
                          "account_name",
                        ) as string;
                        const password = formData.get("password") as string;
                        if (websocket) {
                          createNewAccount(websocket, account_name, password);
                        }
                      }}
                    >
                      <Form.Field className="FormField" name="account_name">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between",
                          }}
                        >
                          <Form.Label
                            className="FormLabel"
                            style={{
                              color:
                                "var(--ro-text)" /* Highlight color to match new color scheme */,
                            }}
                          >
                            Username
                          </Form.Label>
                          <Form.Message
                            className="FormMessage"
                            match="valueMissing"
                          >
                            Please enter your username
                          </Form.Message>
                        </div>
                        <Form.Control asChild>
                          <input
                            className="Input"
                            type="account_name"
                            name={"account_name"}
                            required
                          />
                        </Form.Control>
                      </Form.Field>
                      <Form.Field className="FormField" name="password">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between",
                          }}
                        >
                          <Form.Label
                            className="FormLabel"
                            style={{
                              color:
                                "var(--ro-text)" /* Highlight color to match new color scheme */,
                            }}
                          >
                            Password
                          </Form.Label>
                          <Form.Message
                            className="FormMessage"
                            match="valueMissing"
                          >
                            Please enter your password
                          </Form.Message>
                        </div>
                        <Form.Control asChild>
                          <input
                            className="Input"
                            type="password"
                            name={"password"}
                            required
                          />
                        </Form.Control>
                      </Form.Field>
                      <Form.Submit asChild>
                        <button
                          className="Button"
                          style={{
                            marginTop: 10,
                            border: "1px solid var(--ro-accent)", // Highlight color border
                            padding: "10px",
                            cursor: "pointer",
                            backgroundColor: "var(--ro-panel-solid)", // Dark blue color to match new color scheme
                            color: "var(--ro-text)", // Highlight color to match new color scheme
                            borderRadius: "4px", // Optional: adds rounded corners
                          }}
                        >
                          Create account
                        </button>
                      </Form.Submit>
                    </Form.Root>
                  </Box>
                </Box>
              </Box>
            )}
            {account && (
              <Box
                style={{
                  margin: "10px",
                  padding: "10px",
                  backgroundColor: "rgba(28, 36, 46, 0.85)", // Slightly lighter blue with 90% opacity
                  borderRadius: "4px", // Optional: adds rounded corners
                }}
              >
                <p
                  style={{
                    color:
                      "var(--ro-text)" /* Highlight color to match new color scheme */,
                  }}
                >
                  You are logged in as {account.account_name} .{" "}
                </p>
                <AvatarSelector
                  account={account}
                  onSelectAvatar={(avatarId) => {
                    const updatedAccount = {
                      ...account,
                      player_sprite_id: avatarId,
                    };
                    // console.log("onSelectAvatar: set account");
                    setAccount(updatedAccount);
                    // update the player profile on the server
                    if (websocket != null) {
                      // deferred until actual playerJoin
                      // setPlayerProfile(websocket, avatarId);
                    } else {
                      console.error(
                        "Failed to set player profile: websocket is null",
                      );
                    }
                  }}
                />
                <p style={{ marginTop: "20px" }}>
                  <Link to="/game">Please proceed to the game.</Link>
                </p>
              </Box>
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export default Account;
